<template>
  <div class="transmission-base">
    <h3><span>传习基地</span></h3>
    <div class="wrapper">
      <div id="map"></div>
      <div id="region">
        <div class="region-title">传习基地各七大行政区分布</div>
      </div>
    </div>
    <div class="map-mask" v-if="isMaskShow">
      <h4>北京</h4>
      <ul>
        <li v-for="item of 4" :key="item" @click="handleClickToTransmissionBaseDetail">
          <div class="title">
            <h5>北京陶瓷有限公司</h5>
            <span>中国工艺美术学院</span>
          </div>
          <div>
            <img src="@/assets/img/star.png" class="star" v-for="item of 5" :key="item" />
          </div>
          <p>工坊地址：北京测试工坊地址三门前75号</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "@/assets/data/china";
import { config, positionMap } from "@/assets/data/config";
export default {
  name: "TransmissionBase",
  data() {
    return {
      isMaskShow: false,
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    handleClickToTransmissionBaseDetail() {
      this.$router.push({
        path: "TransmissionBaseDetail",
      });
    },
    initMap() {
      let _this = this;
      var region = document.getElementById("region");
      config.forEach((item) => {
        var reginItem = document.createElement("div");
        reginItem.className = "region-item";
        reginItem.dataset.name = item.name;
        reginItem.style = `--color: ${item.color}`;
        reginItem.innerHTML = `${item.name}地区 ${item.num} 所`;
        region.appendChild(reginItem);
      });
      var myChart = echarts.init(document.getElementById("map"));
      const proviceData = config.reduce((acc, cur) => {
        acc = [
          ...cur.regions.map((region) => {
            const res = {
              name: region,
              value: cur.num,
              emphasis: {
                itemStyle: {
                  areaColor: cur.color,
                },
                label: {
                  position: ["50%", "50%"],
                },
              },
            };
            if (positionMap[region]) {
              res.emphasis.label.position = positionMap[region];
            }
            return res;
          }),
          ...acc,
        ];
        return acc;
      }, []);
      var option = {
        series: [
          {
            name: "中国",
            type: "map",
            map: "china",
            roam: false,
            itemStyle: {
              areaColor: "#eef0f3",
              borderColor: "#a6b0dd",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "10",
                textStyle: {
                  color: "#fff",
                },
              },
              itemStyle: {
                borderColor: "#fff",
              },
            },
            data: proviceData,
          },
        ],
      };
      myChart.setOption(option);
      let currentHighlight = [];
      region.addEventListener("mouseover", function (event) {
        const target = event.target;
        if (target.classList.contains("region-item")) {
          const name = target.dataset.name;
          const data = config.find((item) => item.name === name);
          currentHighlight = data.regions;
          myChart.dispatchAction({
            type: "highlight",
            seriesIndex: 0,
            name: currentHighlight,
          });
        }
      });
      region.addEventListener("mouseout", function (event) {
        myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          name: currentHighlight,
        });
      });
      myChart.on("click", function (data) {
        console.log(data);
        setTimeout(() => {
          _this.isMaskShow = true;
        }, 100);
      });
    },
  },
};
</script>

<style lang="scss">
.transmission-base {
  border-top: 1px solid #f2f2f2;
  padding-top: 30px;
  position: relative;
  h3 {
    width: 1240px;
    margin: 0 auto;
    font: 15px;
    border-bottom: 2px solid #f2f2f2;
    span {
      display: block;
      line-height: 55px;
      width: 159px;
      height: 55px;
      color: #2d3f51;
      border-bottom: 2px solid #2d3f51;
      text-align: center;
    }
  }
  .wrapper {
    width: 1240px;
    height: 1000px;
    margin: -75px auto 0;
    position: relative;
  }
  #map {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  #region {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 280px;
    position: absolute;
    left: 50px;
    bottom: 50px;
  }
  .region-title {
    font-size: 18px;
    margin: 10px;
  }
  .region-item {
    margin: 10px;
    cursor: pointer;
  }
  .region-item::before {
    display: inline-block;
    margin-right: 4px;
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--color);
  }
  .map-mask {
    width: 468px;
    background-color: #fff;
    position: absolute;
    right: 0;
    top: 132px;
    padding: 9px 24px 0 16px;
    box-shadow: 0 2px 6px 2px rgba(0, 0, 0, 0.12);
    h4 {
      line-height: 46px;
      color: #333;
      font-size: 18px;
    }
    ul {
      li {
        border-top: 1px solid #ddd;
        padding: 0 0 35px 32px;
        background: url("../../assets/img/landmark.png") no-repeat 0 21px;
        background-size: 22px 33px;
        cursor: pointer;
        .title {
          display: flex;
          justify-content: space-between;
          h5,
          span {
            margin: 0;
            padding: 25px 0;
            line-height: 16px;
            font-size: 16px;
            color: #333;
          }
          span {
            font-size: 12px;
            color: #555;
          }
        }
        .star {
          width: 14px;
          height: 14px;
          margin: 0 4px 14px 0;
        }
        p {
          font-size: 12px;
          color: #aaa;
          margin: 0;
        }
      }
    }
  }
}
</style>
